import React, { Component } from "react";
import ListP2kb from "./List_p2kb";

class P2kb extends Component {
    render() {
        return (
            <ListP2kb />
        );
    }
}

export default P2kb;